<template>
  <!-- content works -->
  <div class="landing-works">
    <section class="content-works">
      <div class="inside">
        <div class="text-center headline-container" v-if="pageWork.header_text">
          <h1 class="headline" v-in-viewport="{}">{{ pageWork.header_text.value }}</h1>
          <p class="intro_text" v-in-viewport="{}" v-if="pageWork.intro_paragraph">
            {{ pageWork.intro_paragraph.value }}
          </p>
        </div>

        <button
          type="button"
          class="toggle-filter"
          @click="dropSelect()"
          :class="{ isOpen: showSelect }"
        >
          FILTER
        </button>
        <div
          class="filter-container container-fluid"
          v-if="showSelect || !this.$breakpoints.isMobile()"
        >
          <div class="filter">
            <div
              class="select-container selectSolutions"
              :class="{ isOpen: visibleSolutions }"
            >
              <dropdown
                :visible="visibleSolutions"
                @clickOut="visibleSolutions = false"
                :position="position"
                :animation="'ani-fade'"
              >
                <span
                  class="select gtm_Solutions-Filter"
                  @click="
                    visibleSolutions = !visibleSolutions;
                    visibleMarkets = false;
                  "
                  >{{ selectedSolutionTitle }}</span
                >
                <ul slot="dropdown">
                  <li
                    value=""
                    @click="filterBy('solution', $event)"
                    :title="'All Solutions'"
                  >
                    All Solutions
                  </li>
                  <template v-for="(option, index) in taxonomySolutions">
                    <li
                      :key="index"
                      :title="option.name"
                      :value="'&elements.solutions__for_work_[all]=' + option.codename"
                      :codename="option.codename"
                      @click="filterBy('solution', $event)"
                      v-if="option.codename != 'inclusion'"
                    >
                      {{ option.name }}
                    </li>
                  </template>
                </ul>
              </dropdown>
            </div>
            <div
              class="select-container selectMarkets"
              :class="{ isOpen: visibleMarkets }"
            >
              <dropdown
                :visible="visibleMarkets"
                @clickOut="visibleMarkets = false"
                :position="position"
                :animation="'ani-fade'"
              >
                <span
                  class="select gtm_Markets-Filter"
                  @click="
                    visibleMarkets = !visibleMarkets;
                    visibleSolutions = false;
                  "
                  >{{ selectedMarketTitle }}</span
                >
                <ul slot="dropdown">
                  <li value="" @click="filterBy('market', $event)" :title="'All Markets'">
                    All Markets
                  </li>
                  <li
                    v-for="(option, index) in taxonomyMarkets"
                    :key="index"
                    :title="option.name"
                    :value="'&elements.market_categories[all]=' + option.codename"
                    :codename="option.codename"
                    @click="filterBy('market', $event)"
                  >
                    {{ option.name }}
                  </li>
                </ul>
              </dropdown>
            </div>
            <div class="search-container">
              <input
                type="text"
                class="gtm_Search"
                name="search"
                v-model="search"
                placeholder=""
              />
              <img src="dist/search-icon.svg" alt="Search Icon" />
            </div>
          </div>
        </div>

        <boxes-wrapper
          :boxes="filteredWorks"
          :modularContent="modularContent"
          :search="search"
          :boxlimit="8"
        ></boxes-wrapper>
      </div>
    </section>
  </div>
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import boxesWrapper from "../components/boxes-wrapper.vue";
import dropdown from "vue-my-dropdown";
require("../assets/img/search-icon.svg");
require("../assets/img/select-down.svg");

export default {
  name: "Works",
  data() {
    return {
      works: [],
      pageWork: [],
      showSelect: false,
      taxonomySolutions: [],
      taxonomyMarkets: [],
      search: "",
      visibleSolutions: false,
      visibleMarkets: false,
      selectedSolution: "",
      selectedMarket: "",
      selectedSolutionTitle: "All Solutions",
      selectedMarketTitle: "All Markets",
      position: ["left", "bottom", "left", "top"],
      modularContent: [],
    };
  },
  created: function () {
    this.getWork();

    let url = JSON.parse(JSON.stringify(this.$route.query));
    let fw = "";

    if (url.hasOwnProperty("s")) {
      fw = "&elements.solutions__for_work_[all]=" + url.s;
    }

    if (url.hasOwnProperty("m")) {
      fw = fw + "&elements.market_categories[all]=" + url.m;
    }

    if (fw != "") {
      this.filterWorks(fw);
    } else {
      this.getWorks(1000, "inclusion"); // exclude Inclusion
    }

    //Markets - Taxonomies
    if (url.hasOwnProperty("m")) {
      this.getTaxonomyMarkets(url.m);
    } else {
      this.getTaxonomyMarkets();
    }

    //Solutions - Taxonomies
    if (url.hasOwnProperty("s")) {
      this.getTaxonomySolutions(url.s);
    } else {
      this.getTaxonomySolutions();
    }

    window.addEventListener("resize", this.handleResize);
  },
  components: {
    "boxes-wrapper": boxesWrapper,
    dropdown,
  },
  mixins: [apiConnection, seoModule],
  methods: {
    filterBy: function (type, event) {
      let objQuery = JSON.parse(JSON.stringify(this.$route.query));

      if (type == "solution") {
        this.selectedSolution = event.target.attributes.value.value;
        this.visibleSolutions = !this.visibleSolutions;
        this.selectedSolutionTitle = event.target.attributes.title.value;
        this.gtmSelectedSolution = event.target.attributes.title.nodeValue;
        if (event.target.attributes.value.value == "") {
          delete objQuery.s;
        } else {
          objQuery.s = event.target.attributes.codename.value;
        }
      } else if (type == "market") {
        this.selectedMarket = event.target.attributes.value.value;
        this.visibleMarkets = !this.visibleMarkets;
        this.selectedMarketTitle = event.target.attributes.title.value;
        this.gtmSelectedMarket = event.target.attributes.title.nodeValue;
        if (event.target.attributes.value.value == "") {
          delete objQuery.m;
        } else {
          objQuery.m = event.target.attributes.codename.value;
        }
      }

      if (this.selectedSolution == "") {
        //Exclude INCLUSION if selected ALL
        var taxSolList = [];
        taxSolutions = this.taxonomySolutions;
        if (taxSolutions.length) {
          for (var i in taxSolutions) {
            if (taxSolutions[i].codename != "inclusion") {
              taxSolList.push(taxSolutions[i].codename);
              // console.log(taxSolutions[i].codename);
            }
          }
        }
        // console.log(taxSolList.join(","));
        this.selectedSolution =
          "&elements.solutions__for_work_[any]=" + taxSolList.join(",");
      }

      this.filterWorks(this.selectedSolution + this.selectedMarket);
      this.$router.push({ path: "work", query: objQuery });

      var category;

      if (typeof this.gtmSelectedSolution === "undefined") {
        category = this.gtmSelectedMarket;
      } else if (typeof this.gtmSelectedMarket === "undefined") {
        category = this.gtmSelectedSolution;
      } else {
        category = this.gtmSelectedSolution + " & " + this.gtmSelectedMarket;
      }

      this.$gtm.trackEvent({
        event: "click", // Event type [default = 'interaction'] (Optional)
        category: category,
        action: "click",
        label: "Work Page",
        noninteraction: false, // Optional
      });
    },
    dropSelect: function () {
      this.showSelect = !this.showSelect;
    },
    handleResize: function () {
      if (!this.$breakpoints.isMobile()) {
        this.showSelect = true;
      }
    },
  },
  mounted() {
    this.$gtm.trackView("Works Landing", "Works");
    setTimeout(function () {
      $(".st-sticky-share-buttons").removeClass("st-sticky-share-buttons-show");
    }, 500);
  },

  computed: {
    filteredWorks() {
      let result = this.works;
      if (!this.search) return result;

      const search = this.search.toLowerCase();

      const filter = (box) =>
        box.elements.header_title.value.toLowerCase().includes(search) ||
        box.elements.client.value.some((value) =>
          value.name.toLowerCase().includes(search)
        );
      return result.filter(filter);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Works.vue?4c8dedff